class ImageX {

  static async Compress(file, quality = 1){
    let { type } = file; 

    if(!type.includes("image")) return file;
    // Get as image data
    let imageBitmap = await createImageBitmap(file);

    // Draw to canvas
    let canvas = document.createElement("canvas");
    canvas.width = imageBitmap.width;
    canvas.height = imageBitmap.height;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(imageBitmap, 0, 0);

    // Turn into Blob
    return await new Promise((resolve) =>
      canvas.toBlob(resolve, type, quality)
    );

  }

  static async Base64toBlob(b64Data){
    let res = await fetch(b64Data);
    return res.blob();
  }

  static async toBase64(blob){
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  }

}

export default ImageX;